import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Store } from "lucide-react";
 * // Use <Store /> instead
 */
export const StorefrontIcon = createSVGWrapper(
  <path
    clipRule="evenodd"
    d="m4 5a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-12a1 1 0 0 0 -1-1zm2 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm13-2h-10v2h10zm-7 4 4 6h-8z"
    fill="currentColor"
    fillRule="evenodd"
  />
);
